// Copyright (C) 2021 Bystronic Laser AG

import { metricsService } from '@/services/metrics.service';
import { FilterTimeSpanEnum } from '../enums/FilterTimeSpanEnum';
import { WidgetEnum } from '../enums/WidgetEnum';
import { DataRetriever } from './abstract/chartGenerator';
import { CutDeviceCurrentWorkloadData } from './chartsData';

export class WorkCenterConsoleOverviewLaserWorkloadDataRetriever extends DataRetriever<CutDeviceCurrentWorkloadData> {
  constructor(private tenantIdDh: number) {
    super(WidgetEnum.OverviewLaserWorkload);
  }

  override async getData(
    selectedDevices: string[],
    selectedShifts: number[],
    timeSpan: FilterTimeSpanEnum | [string, string],
  ): Promise<CutDeviceCurrentWorkloadData | null> {
    return await metricsService.getDeviceCurrentWorkload(
      selectedDevices[0],
      this.tenantIdDh,
      this.controller,
    );
  }

  async getDataForDevice(selectedDevice: string) {
    return this.getData([selectedDevice], [], FilterTimeSpanEnum.None);
  }
}
